import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToBranding,
  type Branding,
  type BrandingApiResource,
} from './brandingApi.types';

const BRANDING_PATH = '/me/workspace/branding';
const CLIENT_BRANDING_PATH = '/me/branding';

export async function fetchWorkspaceBranding(): Promise<Branding> {
  const response = await httpClient.get<BrandingApiResource>(BRANDING_PATH);
  return mapApiResourceToBranding(response.data);
}

export async function fetchClientWorkspaceBranding(): Promise<Branding> {
  const response = await httpClient.get<BrandingApiResource>(CLIENT_BRANDING_PATH);
  return mapApiResourceToBranding(response.data);
}

export async function updateWorkspaceBrandName(brandName: string | null): Promise<Branding> {
  const response = await httpClient.patch<BrandingApiResource>(BRANDING_PATH, {
    brand_name: brandName,
  });
  return mapApiResourceToBranding(response.data);
}

export async function uploadWorkspaceLogo(variant: string, file: File): Promise<Branding> {
  const formData = new FormData();
  formData.append('file', file);
  const response = await httpClient.post<BrandingApiResource>(
    BRANDING_PATH + '/logos/' + variant,
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return mapApiResourceToBranding(response.data);
}

export async function removeWorkspaceLogo(variant: string): Promise<Branding> {
  const response = await httpClient.delete<BrandingApiResource>(BRANDING_PATH + '/logos/' + variant);
  return mapApiResourceToBranding(response.data);
}
